module.exports = __webpack_public_path__ + "img/FR17919.08924a80.png";